"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * A base error.
 * @param message the message
 */
class BaseError extends Error {
    constructor(message) {
        super(message);
        /* istanbul ignore next */
        if (Error.captureStackTrace) {
            Error.captureStackTrace(this, this.constructor);
        }
        Object.defineProperty(this, "name", {
            value: this.constructor.name,
        });
    }
}
/**
 * A parsing error.
 */
class ParseError extends BaseError {
}
exports.ParseError = ParseError;
/**
 * A formatting error.
 */
class FormatError extends BaseError {
}
exports.FormatError = FormatError;
//# sourceMappingURL=errors.js.map